import { render } from "./NotificationsPage.vue?vue&type=template&id=4453df3c&ts=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=ts"
export * from "./NotificationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Notifications/NotificationsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4453df3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4453df3c', __exports__)) {
    api.reload('4453df3c', __exports__)
  }
  
  module.hot.accept("./NotificationsPage.vue?vue&type=template&id=4453df3c&ts=true", () => {
    api.rerender('4453df3c', render)
  })

}


export default __exports__